export default {
	canceled: {
		code: 'CANCELED',
		name: 'anulado',
	},
	requested: {
		code: 'REQUESTED',
		name: 'solicitado',
	},
	inRoad: {
		code: 'IN_ROAD',
		name: 'en camino',
	},
	given: {
		code: 'GIVEN',
		name: 'entregado',
	},
	confirmed: {
		code: 'CONFIRMED',
		name: 'confirmado',
	},
	readyToDeliver: {
		code: 'READY_TO_DELIVER',
		name: 'listo para entregar',
	},
};



// WEBPACK FOOTER //
// ./src/shared/enums/orderStateId.js